import { Navigate, Route, Routes } from 'react-router-dom'
import HomePage from '@/pages/HomePage'
import BrandsPage from '@/pages/BrandsPage'
import RealEstatePage from '@/pages/RealEstatePage'
import NotFoundPage from '@/pages/NotFoundPage'
import AdminPage from '@/pages/AdminPage'

function App() {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="/brands" element={<BrandsPage />} />
      <Route path="/real-estate" element={<RealEstatePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/locations" element={<Navigate to="/real-estate" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default App
